import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const UPDATE_EDIT_NODE = 'UPDATE_EDIT_NODE';
export const UPDATE_EDIT_NODE_CREDENTIALS = 'UPDATE_EDIT_NODE_CREDENTIALS';
export const SET_LOADING_EXTRA_FIELDS = 'SET_LOADING_EXTRA_FIELDS';
export const SET_NODE_PARAMS = 'SET_NODE_PARAMS';
export const SET_NODE_PARAMS_ID = 'SET_NODE_PARAMS_ID';
export const SET_EDIT_NODE = 'SET_EDIT_NODE';
export const SET_NEED_EXTRA_FIELDS = 'SET_NEED_EXTRA_FIELDS';
export const SET_SIDE_BAR_STATE = 'SET_SIDE_BAR_STATE';
export const SET_GET_EXTRA_FIELDS_PROMISE = 'SET_GET_EXTRA_FIELDS_PROMISE';
export const IS_FLOW_TREE_DRAGGING = 'IS_FLOW_TREE_DRAGGING';
export const DATA_SOURCE_DISPLAY = 'DATA_SOURCE_DISPLAY';
export const SET_IS_NODE_DATA_LOADING = 'SET_IS_NODE_DATA_LOADING';
export const SET_FORCE_LOAD_DYNAMIC_FIELDS = 'SET_FORCE_LOAD_DYNAMIC_FIELDS';
export const SET_TESTING_PROFILE = 'SET_TESTING_PROFILE';
export const SYNC_TEMP_EDIT_NODE_COPY = 'SYNC_TEMP_EDIT_NODE_COPY';
export const RESET_TEMP_EDIT_NODE_COPY = 'RESET_TEMP_EDIT_NODE_COPY';
export const ADD_AFTER_UPDATE_EDIT_NODE_HANDLER = 'ADD_AFTER_UPDATE_EDIT_NODE_HANDLER';
export const RESET_AFTER_UPDATE_EDIT_NODE_HANDLERS = 'RESET_AFTER_UPDATE_EDIT_NODE_HANDLERS';
export const RESET_ATTRIBUTES_TO_UPDATE = 'RESET_ATTRIBUTES_TO_UPDATE';
export const ADD_ATTRIBUTE_TO_UPDATE = 'ADD_ATTRIBUTE_TO_UPDATE';
export const ADD_AUTOFILL = 'ADD_AUTOFILL';
export const RESET_AUTOFILL = 'RESET_AUTOFILL';
export const REMOVE_AUTOFILL = 'REMOVE_AUTOFILL';
export const SET_IS_AUTOFILL_LOADING = 'SET_IS_AUTOFILL_LOADING';
export const SET_AUTOFILL_ERROR = 'SET_AUTOFILL_ERROR';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[UPDATE_EDIT_NODE](state, payload) {
		const { key, value } = payload;
		Vue.set(state.editNode, key, value);
	},
	[UPDATE_EDIT_NODE_CREDENTIALS](state, payload) {
		const { key, value } = payload;
		Vue.set(state.editNode.credentials_configuration, key, value);
	},
	[SET_LOADING_EXTRA_FIELDS](state, value) {
		Vue.set(state, 'loadingExtraFields', value);
	},
	[SET_NODE_PARAMS](state, params) {
		Vue.set(state, 'editNodeParams', params);
	},
	[SET_NODE_PARAMS_ID](state, nodeId) {
		Vue.set(state, 'editNodeParamsId', nodeId);
	},
	[SET_EDIT_NODE](state, node) {
		Vue.set(state, 'editNode', node);
	},
	[SET_NEED_EXTRA_FIELDS](state, value) {
		Vue.set(state, 'needExtraFields', value);
	},
	[SET_SIDE_BAR_STATE](state, value) {
		Vue.set(state, 'sideBarState', value);
	},
	[SET_GET_EXTRA_FIELDS_PROMISE](state, promise) {
		Vue.set(state, 'getExtraFieldsPromise', promise);
	},
	[IS_FLOW_TREE_DRAGGING](state, promise) {
		Vue.set(state, 'isFlowTreeDragging', promise);
	},
	[SET_IS_NODE_DATA_LOADING](state, promise) {
		Vue.set(state, 'isNodeDataLoading', promise);
	},
	[SET_FORCE_LOAD_DYNAMIC_FIELDS](state, value) {
		Vue.set(state, 'forceLoadDynamicFields', value);
	},
	[SET_TESTING_PROFILE](state, value) {
		Vue.set(state, 'testingProfile', value);
	},
	[SYNC_TEMP_EDIT_NODE_COPY](state) {
		Vue.set(state, 'tempEditNodeCopy', JSON.parse(JSON.stringify(state.editNode)));
	},
	[RESET_TEMP_EDIT_NODE_COPY](state) {
		Vue.set(state, 'tempEditNodeCopy', null);
	},
	[ADD_AFTER_UPDATE_EDIT_NODE_HANDLER](state, handler) {
		state.afterUpdateEditNodeHandlers.push(handler);
	},
	[RESET_AFTER_UPDATE_EDIT_NODE_HANDLERS](state) {
		Vue.set(state, 'afterUpdateEditNodeHandlers', []);
	},
	[RESET_ATTRIBUTES_TO_UPDATE](state) {
		Vue.set(state, 'nodeAttributesToUpdate', []);
	},
	[ADD_ATTRIBUTE_TO_UPDATE](state, attributeKey) {
		state.nodeAttributesToUpdate.push(attributeKey);
	},
	[ADD_AUTOFILL](state, { paramKey, value }) {
		if (!(paramKey in state.autofillSuggestions)) {
			Vue.set(state.autofillSuggestions, paramKey, []);
		}
		state.autofillSuggestions[paramKey].push(value);
	},
	[REMOVE_AUTOFILL](state, { paramKey, value }) {
		const suggestionsAfterRemoval = state.autofillSuggestions[paramKey].filter((suggestion) => suggestion !== value);
		Vue.set(state.autofillSuggestions, paramKey, suggestionsAfterRemoval);
	},
	[RESET_AUTOFILL](state) {
		Vue.set(state, 'autofillSuggestions', {});
	},
	[SET_IS_AUTOFILL_LOADING](state, isAutofillLoading) {
		Vue.set(state, 'isAutofillLoading', isAutofillLoading);
	},
	[SET_AUTOFILL_ERROR](state, error) {
		Vue.set(state, 'autofillError', error);
	},
};

export default mutations;
